module.exports = __webpack_public_path__ + "static/media/top-bg.05db3840.png";